/* =========================================================
   Search results filtering fix
   ------------------------------------------------------------
   The theme's built-in search-page filtering doesn't work: the
   filter component updates the URL but never re-renders the
   results, and it searches ALL result types (article,product,
   page) at once, which disables Shopify's product filters. The
   RESULT TYPE checkboxes are also not wired to anything.

   This script makes the filters work by turning every filter
   interaction into a proper full-page navigation:
     1) Facet filters (colour / weight / price / material) and
        the sort dropdown -> reload scoped to products so the
        filters actually apply, preserving the search query.
     2) "Remove" facet chips and "clear all" -> full reload.
     3) RESULT TYPE checkboxes (product / page / article) ->
        reload with the matching ?type= value.

   Runs only on the search results page. Fully defensive: any
   error falls back to the theme's default behaviour.
   ============================================================ */
(function () {
  'use strict';

  try {
    if (!/template-search/.test(document.body.className)) return;
    if (window.__selvageSearchFilterFix) return;
    window.__selvageSearchFilterFix = true;
  } catch (e) { return; }

  function curUrl() { return new URL(window.location.href); }
  function curQ() { return curUrl().searchParams.get('q') || ''; }

  // Navigate (full load) and keep the theme-preview param if we're previewing.
  function go(u) {
    try {
      var p = curUrl().searchParams.get('preview_theme_id');
      if (p) u.searchParams.set('preview_theme_id', p);
    } catch (e) {}
    window.location.assign(u.toString());
  }

  var form = document.getElementById('CollectionFiltersForm');

  // 1) Facet form: any filter or sort change -> product-scoped full navigation.
  if (form) {
    form.addEventListener('change', function (e) {
      var t = e.target;
      if (!t || !t.name) return;
      if (!/^filter\./.test(t.name) && t.name !== 'sort_by') return;
      e.stopImmediatePropagation();
      e.preventDefault();
      var u = new URL('/search', window.location.origin);
      var q = curQ();
      if (q) u.searchParams.set('q', q);
      var hasProductFilter = false;
      var fd = new FormData(form);
      fd.forEach(function (v, k) {
        var val = (v == null ? '' : String(v)).trim();
        if (val === '') return;
        if (/^filter\./.test(k)) {
          u.searchParams.append(k, v);
          if (/^filter\.v\./.test(k)) hasProductFilter = true;
        } else if (k === 'sort_by') {
          u.searchParams.set('sort_by', v);
        }
      });
      u.searchParams.set('type', hasProductFilter ? 'product' : (curUrl().searchParams.get('type') || 'product'));
      go(u);
    }, true);
  }

  // 2) Active-facet "remove" chips and "clear all" -> ensure a real full reload.
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!a || !a.closest('.active-facets')) return;
    var href = a.getAttribute('href');
    if (!href || href.indexOf('/search') === -1) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    go(new URL(href, window.location.origin));
  }, true);

  // 3) RESULT TYPE checkboxes (product / page / article) -> reload with ?type=.

  // Reflect the active ?type= in the checkboxes. The theme renders them unchecked
  // and, once a type is applied, drops the other type options from the list - so
  // without this you get stuck (e.g. on "page" with no way back to "product").
  // Showing the active type as checked lets the user uncheck it to return to all
  // results, where every result type becomes available again.
  (function syncResultTypeState() {
    var ct = curUrl().searchParams.get('type');
    var active = ct ? ct.split(',') : [];
    ['product', 'page', 'article'].forEach(function (tp) {
      var cb = document.getElementById('Filter-' + tp);
      if (cb && !cb.disabled) cb.checked = (active.indexOf(tp) !== -1);
    });
  })();

  ['product', 'page', 'article'].forEach(function (tp) {
    var cb = document.getElementById('Filter-' + tp);
    if (!cb || cb.disabled) return;
    cb.addEventListener('change', function () {
      var types = [];
      ['product', 'page', 'article'].forEach(function (x) {
        var c = document.getElementById('Filter-' + x);
        if (c && c.checked && !c.disabled) types.push(x);
      });
      var u = new URL('/search', window.location.origin);
      var q = curQ();
      if (q) u.searchParams.set('q', q);
      if (types.length) u.searchParams.set('type', types.join(','));
      go(u);
    });
  });
})();
